import React from 'react';

import { Navigate } from 'react-router-dom';

import { isPlaygroundEnvironment } from './isPlaygroundEnvironment';

/**
 * Environment gate for the design-system Playground.
 * Mirrors AdminRoute's redirect target when the env allowlist rejects.
 * Compose with AdminRoute so both admin profile and env must pass.
 */
export function PlaygroundRoute({ children }: { children: React.ReactNode }) {
  if (!isPlaygroundEnvironment()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <>{children}</>;
}
